interface IBrandUserRole {
  brandUserRoleId: number;
  brandUserRoleAppId: number;
  brandUserRoleKey: string;
  brandUserRoleName: string;
  brandUserRoleDescription: string;
}

interface DBrandUserRole {
  brandUserRoleId: number;
  brandUserRoleKey: string;
  brandUserRoleName: string;
  brandUserRoleAppId: number;
  brandUserRoleDescription: string;
}

interface IBrandUser {
  brandUserId: number;
  brandUserName: string;
  brandUserEmail: string;
  brandUserRoles: BrandUserRole[];
  brandAppUserId: number;
  brandUserIsActive: boolean;
  brandUserCreatedAt: string | null;
  brandUserCreatedBy: number | null;
  brandOrganizationUserId: number;
}

interface DBrandUser {
  brandUserId: number;
  brandUserName: string;
  brandUserEmail: string;
  brandUserRoles: DBrandUserRole[];
  brandAppUserId: number;
  brandUserIsActive: boolean;
  brandUserCreatedAt: string | null;
  brandUserCreatedBy: number | null;
  brandOrganizationUserId: number;
}

class BrandUserRole implements IBrandUserRole {
  private readonly _brandUserRoleId: number;
  private readonly _brandUserRoleAppId: number;
  private readonly _brandUserRoleKey: string;
  private readonly _brandUserRoleName: string;
  private readonly _brandUserRoleDescription: string;

  constructor(props: DBrandUserRole) {
    this._brandUserRoleId = props.brandUserRoleId;
    this._brandUserRoleAppId = props.brandUserRoleAppId;
    this._brandUserRoleKey = props.brandUserRoleKey;
    this._brandUserRoleName = props.brandUserRoleName;
    this._brandUserRoleDescription = props.brandUserRoleDescription;
  }

  get brandUserRoleId(): number {
    return this._brandUserRoleId;
  }

  get brandUserRoleAppId(): number {
    return this._brandUserRoleAppId;
  }

  get brandUserRoleKey(): string {
    return this._brandUserRoleKey;
  }

  get brandUserRoleName(): string {
    return this._brandUserRoleName;
  }

  get brandUserRoleDescription(): string {
    return this._brandUserRoleDescription;
  }

  static from(props: DBrandUserRole): BrandUserRole {
    return new BrandUserRole(props);
  }
}

class BrandUser implements IBrandUser {
  private readonly _brandUserId: number;
  private readonly _brandUserName: string;
  private readonly _brandUserEmail: string;
  private readonly _brandUserRoles: BrandUserRole[];
  private readonly _brandAppUserId: number;
  private readonly _brandUserIsActive: boolean;
  private readonly _brandUserCreatedAt: string | null;
  private readonly _brandUserCreatedBy: number | null;
  private readonly _brandOrganizationUserId: number;

  constructor(props: DBrandUser) {
    this._brandUserId = props.brandUserId;
    this._brandUserName = props.brandUserName;
    this._brandUserEmail = props.brandUserEmail;
    this._brandUserRoles = (props.brandUserRoles ?? []).map((role) =>
      BrandUserRole.from(role),
    );
    this._brandAppUserId = props.brandAppUserId;
    this._brandUserIsActive = props.brandUserIsActive;
    this._brandUserCreatedAt = props.brandUserCreatedAt;
    this._brandUserCreatedBy = props.brandUserCreatedBy;
    this._brandOrganizationUserId = props.brandOrganizationUserId;
  }

  get brandUserId(): number {
    return this._brandUserId;
  }

  get brandUserName(): string {
    return this._brandUserName;
  }

  get brandUserEmail(): string {
    return this._brandUserEmail;
  }

  get brandUserRoles(): BrandUserRole[] {
    return this._brandUserRoles;
  }

  get brandAppUserId(): number {
    return this._brandAppUserId;
  }

  get brandUserIsActive(): boolean {
    return this._brandUserIsActive;
  }

  get brandUserCreatedAt(): string | null {
    return this._brandUserCreatedAt;
  }

  get brandUserCreatedBy(): number | null {
    return this._brandUserCreatedBy;
  }

  get brandOrganizationUserId(): number {
    return this._brandOrganizationUserId;
  }

  static from(props: DBrandUser): BrandUser {
    return new BrandUser(props);
  }
}

export type { IBrandUser, DBrandUser, IBrandUserRole, DBrandUserRole };
export { BrandUser, BrandUserRole };

